import { Box } from '@chakra-ui/react';
import { format } from 'date-fns';

// Brand-solid date chip ("THU JUN 18") shown in panel-screen headers so the
// selected date visibly carries through the add-to-date flow (curBrowse →
// curPlans). `date` is a yyyy-MM-dd string; parsed at local midnight to avoid
// the off-by-one a bare `new Date('yyyy-MM-dd')` (UTC) would give.
export default function DatePill({ date }: { date: string }) {
  return (
    <Box
      bg='brand.solid'
      color='brand.contrast'
      borderRadius='full'
      px={3}
      py={1}
      fontFamily='heading'
      fontWeight='700'
      fontSize='label'
      textTransform='uppercase'
      letterSpacing='label'
      whiteSpace='nowrap'
    >
      {format(new Date(`${date}T00:00:00`), 'EEE MMM d')}
    </Box>
  );
}
